/**
 * 서버 시간 동기화 처리 클래스
 * - 서버와 클라이언트 간 시간 차(offset)을 보관
 * - 실제 현재시간은 항상 offset을 적용해 계산한다.
 */
class ServerTime {
    private offsetMillis = 0;

    /**
     * 서버시간 초기화
     * @param serverNowMillis 서버시간 현재 시각
     * @param receivedAtMillis 클라이언트가 응답을 받은 시각
     */
    init(serverNowMillis: number, receivedAtMillis: number) {
        this.offsetMillis = serverNowMillis - receivedAtMillis;
    }

    /**
     * 서버기준 현재 Date
     * @returns
     */
    now(): Date {
        return new Date(Date.now() + this.offsetMillis);
    }

    /**
     * 서버 기준 현재 epoch(ms)
     * @returns
     */
    nowMillis(): number {
        return Date.now() + this.offsetMillis;
    }
}

export const serverTime = new ServerTime();
